import { render, staticRenderFns } from "./Substitution.vue?vue&type=template&id=e43c83b4&scoped=true&"
import script from "./Substitution.vue?vue&type=script&lang=js&"
export * from "./Substitution.vue?vue&type=script&lang=js&"
import style0 from "./Substitution.vue?vue&type=style&index=0&id=e43c83b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43c83b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e43c83b4')) {
      api.createRecord('e43c83b4', component.options)
    } else {
      api.reload('e43c83b4', component.options)
    }
    module.hot.accept("./Substitution.vue?vue&type=template&id=e43c83b4&scoped=true&", function () {
      api.rerender('e43c83b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AssignationMultiple/Substitution.vue"
export default component.exports